module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Doerflingen-705ce2ae66bbb70b0e1544d31af36007.png";